import React, { useEffect, useState, useRef } from "react"
import axios from "axios"
import BotaoExportar from "../components/BotaoExportar"
import { useAuth } from "../contexts/AuthContext"
import "../design/tokens.css"

const API = process.env.REACT_APP_API_URL || "http://localhost:3001/api"

const FORM_VAZIO = {
  nome:"", cnh:"", cnh_vencimento:"", telefone:"",
  rfid_tag:"", cliente_id:"", funcao_id:"", setor_id:"", foto_url:"",
  motorista_global:false, cpf:""
}


// ---------------------------------------------------------------- ESTILO (tokens em design/tokens.css)
const CSS = `
.mt{--mt-vidro:rgba(17,24,39,.8);--mt-borda:rgba(255,255,255,.14);position:relative;isolation:isolate;height:100%;overflow:auto;overscroll-behavior:contain;padding:1.5rem;box-sizing:border-box;background:var(--color-background);color:var(--color-foreground);font:100%/1.5 system-ui,-apple-system,'Segoe UI','SF Pro Text',Roboto,sans-serif;font-optical-sizing:auto}
.mt::before{content:"";position:fixed;inset:0;z-index:-1;pointer-events:none;background:radial-gradient(44rem 24rem at 10% 0%,rgba(11,102,234,.14),transparent 62%),radial-gradient(36rem 22rem at 100% 100%,rgba(25,158,112,.09),transparent 62%)}
.mt-topo{display:flex;justify-content:space-between;align-items:flex-end;gap:1rem;flex-wrap:wrap;margin-bottom:1.1rem}
.mt-topo h2{margin:0;font-size:1.75rem;line-height:1.1;letter-spacing:-.025em;font-weight:700}
.mt-mini{font-size:.8125rem;letter-spacing:.005em;color:var(--color-muted-foreground);margin:.2rem 0 0}
.mt-acoes{display:flex;gap:.5rem;align-items:center}
.mt .btn{border-radius:.875rem;min-height:2.5rem;padding:0 1rem;font-family:inherit;transition:transform 100ms ease-out,background-color 100ms ease-out,border-color 100ms ease-out;touch-action:manipulation}
.mt .btn:active:not(:disabled){transform:scale(.97)}
.mt .btn:disabled{opacity:.6;cursor:default}
.mt .btn:focus-visible,.mt-icone:focus-visible,.mt-fechar:focus-visible{outline:3px solid var(--color-ring);outline-offset:2px}
.mt .btn-primary{background:var(--color-primary);font-weight:600}
.mt .btn-primary:hover:not(:disabled){background:var(--color-primary-hover)}
.mt .btn-primary:active:not(:disabled){background:var(--color-primary-active)}
.mt .btn-ghost{border-color:var(--color-border-strong)}
.mt .btn-perigo{color:var(--color-danger)}
.mt input.mt-campo,.mt select.mt-campo{background:var(--color-surface) !important;color:var(--color-foreground) !important;border:1px solid var(--color-border-strong);border-radius:.875rem;height:2.75rem;padding:0 .9rem;font-size:1rem;font-family:inherit;box-sizing:border-box;width:100%;transition:border-color 120ms,box-shadow 120ms}
.mt input.mt-campo:focus,.mt select.mt-campo:focus{border-color:var(--color-primary);box-shadow:var(--primitive-shadow-focus)}
.mt input.mt-campo::placeholder{color:var(--color-muted-foreground)}
.mt-busca{max-width:25rem;margin-bottom:1rem}
.mt-cartao{border-radius:1.25rem;background:var(--color-surface);border:1px solid var(--color-border);overflow:hidden}
.mt-rolagem{overflow-x:auto}
.mt-tabela{width:100%;border-collapse:separate;border-spacing:0;min-width:56rem}
.mt-tabela th{padding:.75rem 1rem;text-align:left;font-size:.6875rem;font-weight:600;letter-spacing:.05em;text-transform:uppercase;color:var(--color-muted-foreground);border-bottom:1px solid var(--color-border);white-space:nowrap}
.mt-tabela td{padding:.65rem 1rem;font-size:.8125rem;border-bottom:1px solid var(--color-border);vertical-align:middle}
.mt-tabela tbody tr:last-child td{border-bottom:0}
.mt-tabela tbody tr{transition:background-color 100ms ease-out}
.mt-tabela tbody tr:hover{background:var(--color-surface-raised)}
.mt-vazio{padding:2rem;text-align:center;color:var(--color-muted-foreground)}
.mt-nome{font-weight:600;font-size:.875rem;letter-spacing:-.005em}
.mt-sub{font-size:.6875rem;color:var(--color-muted-foreground)}
.mt-mono{font-family:ui-monospace,SFMono-Regular,Menlo,Consolas,monospace}
.mt-avatar{width:2.5rem;height:2.5rem;border-radius:50%;object-fit:cover;display:grid;place-items:center;background:var(--color-primary-soft);color:var(--color-primary);font-weight:700;font-size:1rem;border:1px solid var(--color-border);flex:none}
.mt-pilula{display:inline-flex;align-items:center;gap:.3rem;border-radius:999px;padding:.12rem .55rem;font-size:.6875rem;font-weight:600;white-space:nowrap;background:var(--color-surface-raised);color:var(--color-muted-foreground)}
.mt-pilula.ok{background:var(--color-success-bg);color:var(--color-success)}
.mt-pilula.aviso{background:var(--color-warning-bg);color:var(--color-warning)}
.mt-pilula.perigo{background:var(--color-danger-bg);color:var(--color-danger)}
.mt-pilula.info{background:var(--color-info-bg);color:var(--color-info)}
.mt-zap{display:inline-flex;align-items:center;gap:.35rem;text-decoration:none;color:#25d366;font-weight:500}
.mt-zap:focus-visible{outline:3px solid var(--color-ring);outline-offset:2px;border-radius:.4rem}
.mt-linha-acoes{display:flex;gap:.35rem}
.mt-icone{width:2.25rem;height:2.25rem;border-radius:50%;border:0;background:transparent;color:var(--color-muted-foreground);display:grid;place-items:center;cursor:pointer;transition:transform 100ms ease-out,background-color 100ms ease-out,color 100ms ease-out;touch-action:manipulation}
.mt-icone:hover{background:var(--color-surface-raised);color:var(--color-foreground)}
.mt-icone:active{transform:scale(.92)}
.mt-icone.perigo:hover{color:var(--color-danger);background:var(--color-danger-bg)}
.mt-cortina{position:fixed;inset:0;z-index:1000;display:flex;align-items:center;justify-content:center;padding:1.25rem;background:rgba(2,6,15,.55);backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px);animation:mt-cortina 200ms ease-out both}
.mt-cortina.alto{z-index:1100}
.mt-folha{width:100%;max-width:35rem;max-height:90vh;display:flex;flex-direction:column;border-radius:1.5rem;background:var(--mt-vidro);backdrop-filter:blur(22px) saturate(180%);-webkit-backdrop-filter:blur(22px) saturate(180%);border:1px solid var(--mt-borda);border-top-color:rgba(255,255,255,.25);box-shadow:0 1px 2px rgba(0,0,0,.4),0 24px 64px rgba(0,0,0,.5);color:var(--color-foreground);animation:mt-folha 260ms cubic-bezier(.22,1,.36,1) both}
.mt-folha.estreita{max-width:32.5rem}
.mt-cab{display:flex;justify-content:space-between;align-items:center;gap:1rem;padding:1.15rem 1.5rem .5rem}
.mt-cab h3{margin:0;font-size:1.25rem;letter-spacing:-.02em;font-weight:650}
.mt-fechar{width:2rem;height:2rem;border-radius:50%;border:0;background:var(--color-surface-raised);color:var(--color-muted-foreground);cursor:pointer;display:grid;place-items:center;font:inherit;font-size:.9rem;transition:transform 100ms ease-out,background-color 100ms ease-out}
.mt-fechar:active{transform:scale(.92)}
.mt-corpo{padding:.75rem 1.5rem 1rem;overflow-y:auto;overscroll-behavior:contain}
.mt-rodape{display:flex;gap:.5rem;justify-content:flex-end;padding:.9rem 1.5rem 1.15rem;border-top:1px solid var(--color-border)}
.mt-topo-form{display:grid;grid-template-columns:7.2rem minmax(0,1fr);gap:1.25rem;margin-bottom:1.1rem}
.mt-foto{width:7.1rem;height:9.5rem;border-radius:1rem;cursor:pointer;overflow:hidden;position:relative;border:2px dashed var(--color-border-strong);background:var(--color-surface);display:flex;flex-direction:column;align-items:center;justify-content:center;gap:.25rem;padding:0;color:var(--color-muted-foreground);font:inherit;transition:border-color 120ms,transform 100ms ease-out}
.mt-foto:hover{border-color:var(--color-primary)}
.mt-foto:active{transform:scale(.97)}
.mt-foto:focus-visible{outline:3px solid var(--color-ring);outline-offset:2px}
.mt-foto img{width:100%;height:100%;object-fit:cover}
.mt-foto small{position:absolute;bottom:0;left:0;right:0;padding:.2rem 0;text-align:center;font-size:.625rem;background:rgba(0,0,0,.6);color:#cbd5e1}
.mt-foto span{font-size:.6875rem;text-align:center;line-height:1.35}
.mt-grade{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:.8rem}
.mt-grade .cheio{grid-column:1/-1}
.mt-grupo{display:flex;flex-direction:column;gap:.3rem;min-width:0}
.mt-rotulo{display:block;font-size:.75rem;letter-spacing:.012em;color:var(--color-muted-foreground);margin:0}
.mt-dica{font-size:.75rem;margin:0;color:var(--color-muted-foreground)}
.mt-dica.ok{color:var(--color-success)}.mt-dica.aviso{color:var(--color-warning)}.mt-dica.perigo{color:var(--color-danger)}
.mt-troca{display:flex;align-items:flex-start;gap:.8rem;cursor:pointer;margin:0;font-size:.875rem;color:var(--color-foreground)}
.mt-troca input{position:absolute;opacity:0;width:1px;height:1px;margin:0;pointer-events:none}
.mt-trilho{flex:none;width:2.75rem;height:1.6rem;border-radius:999px;background:var(--color-border-strong);position:relative;transition:background-color 180ms ease-out;margin-top:.1rem}
.mt-trilho::after{content:"";position:absolute;top:.15rem;left:.15rem;width:1.3rem;height:1.3rem;border-radius:50%;background:#fff;box-shadow:0 1px 3px rgba(0,0,0,.35);transition:transform 220ms cubic-bezier(.22,1,.36,1)}
.mt-troca input:checked + .mt-trilho{background:var(--color-success)}
.mt-troca input:checked + .mt-trilho::after{transform:translateX(1.15rem)}
.mt-troca input:focus-visible + .mt-trilho{outline:3px solid var(--color-ring);outline-offset:2px}
.mt-troca:active .mt-trilho::after{width:1.5rem}
.mt-troca b{display:block;font-weight:600}
.mt-troca small{display:block;font-size:.75rem;color:var(--color-muted-foreground);margin-top:.15rem;font-weight:400}
.mt-bloco{border-top:1px solid var(--color-border);padding-top:.9rem;margin-top:.9rem}
.mt-link{background:none;border:0;color:var(--color-primary);font:inherit;font-size:.75rem;cursor:pointer;padding:.15rem 0;border-radius:.4rem;transition:opacity 100ms}
.mt-link:active{opacity:.6}
.mt-caixa{border-radius:1rem;padding:.85rem 1rem;background:var(--color-surface);border:1px solid var(--color-border-strong);font-size:.875rem}
.mt-caixa.ok{border-color:var(--color-success);background:var(--color-success-bg)}
.mt-caixa.aviso{border-color:var(--color-warning);background:var(--color-warning-bg)}
.mt-segs{display:flex;gap:.4rem;flex-wrap:wrap}
.mt-seg{position:relative;margin:0;cursor:pointer}
.mt-seg input{position:absolute;opacity:0;width:1px;height:1px;margin:0}
.mt-seg span{display:block;padding:.45rem .9rem;border-radius:999px;border:1px solid var(--color-border-strong);font-size:.8125rem;color:var(--color-muted-foreground);transition:background-color 120ms,color 120ms,border-color 120ms,transform 100ms ease-out}
.mt-seg:active span{transform:scale(.97)}
.mt-seg input:checked + span{background:var(--color-primary);border-color:var(--color-primary);color:#fff;font-weight:600}
.mt-seg input:focus-visible + span{outline:3px solid var(--color-ring);outline-offset:2px}
.mt-erro{color:var(--color-danger);font-size:.8125rem}
.mt-senha{margin-top:.5rem;border-radius:.75rem;padding:.7rem .85rem;background:rgba(0,0,0,.35);font-size:.875rem}
@keyframes mt-cortina{from{opacity:0}to{opacity:1}}
@keyframes mt-folha{from{opacity:0;transform:translateY(14px) scale(.98)}to{opacity:1;transform:none}}
@media (max-width:640px){
  .mt{padding:1rem}
  .mt-cortina{align-items:flex-end;padding:0}
  .mt-folha,.mt-folha.estreita{max-width:none;max-height:92vh;border-radius:1.5rem 1.5rem 0 0}
  .mt-topo-form{grid-template-columns:1fr}
  .mt-foto{margin:0 auto}
  .mt-grade{grid-template-columns:1fr}
}
@media (prefers-reduced-motion:reduce){
  .mt-cortina,.mt-folha{animation:none}
  .mt .btn,.mt-icone,.mt-fechar,.mt-foto,.mt-seg span,.mt-trilho,.mt-trilho::after{transition:none}
  .mt .btn:active:not(:disabled),.mt-icone:active,.mt-fechar:active,.mt-foto:active,.mt-seg:active span{transform:none}
}
@media (prefers-reduced-transparency:reduce){
  .mt-folha{background:var(--color-surface-raised);backdrop-filter:none;-webkit-backdrop-filter:none}
  .mt-cortina{backdrop-filter:none;-webkit-backdrop-filter:none;background:rgba(2,6,15,.75)}
}
@media (prefers-contrast:more){
  .mt-folha{background:var(--color-surface-raised);border-color:var(--color-foreground)}
  .mt .btn-ghost,.mt input.mt-campo,.mt select.mt-campo{border-color:var(--color-foreground)}
}
`

const Icone = ({ nome }: { nome: "editar"|"lixo"|"celular" }) => {
  const caminhos: Record<string,string> = {
    editar: "M12 20h9M16.5 3.5a2.1 2.1 0 013 3L7 19l-4 1 1-4 12.5-12.5z",
    lixo: "M3 6h18M8 6V4h8v2m-9 0l1 14h8l1-14M10 11v6M14 11v6",
    celular: "M7 2h10a1 1 0 011 1v18a1 1 0 01-1 1H7a1 1 0 01-1-1V3a1 1 0 011-1zm5 17h.01",
  }
  return <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d={caminhos[nome]} /></svg>
}

// fecha com Esc (so enquanto "ativo")
function useEsc(ativo: boolean, fechar: () => void) {
  useEffect(() => {
    if (!ativo) return
    const h = (e: KeyboardEvent) => { if (e.key === "Escape") fechar() }
    document.addEventListener("keydown", h)
    return () => document.removeEventListener("keydown", h)
  }, [ativo, fechar])
}

// ---------------------------------------------------------------- ACESSO DO MOTORISTA AO APP
const soDigitos = (v:any) => String(v??"").replace(/\D/g,"")
const fmtCpf = (v:any) => soDigitos(v).slice(0,11).replace(/(\d{3})(\d)/,"$1.$2").replace(/(\d{3})(\d)/,"$1.$2").replace(/(\d{3})(\d{1,2})$/,"$1-$2")
const cpfValido = (v:any) => {
  const c = soDigitos(v)
  if (c.length !== 11 || /^(\d)\1{10}$/.test(c)) return false
  const dv = (base:string, p:number) => { let s = 0; for (let i=0;i<base.length;i++) s += Number(base[i])*(p-i); const r = (s*10)%11; return r===10?0:r }
  return dv(c.slice(0,9),10)===Number(c[9]) && dv(c.slice(0,10),11)===Number(c[10])
}
const celularValido = (v:any) => {
  let d = soDigitos(v); if (d.length===10 || d.length===11) d = "55"+d
  return /^55\d{10,11}$/.test(d) && Number(d.slice(2,4))>=11 && !(d.length===13 && d[4]!=="9")
}
const EMAIL_RX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/

function AcessoApp({ motorista, API, onFechar, onMudou }: { motorista:any, API:string, onFechar:()=>void, onMudou:()=>void }) {
  const [status, setStatus]       = useState<any>(null)            // null = carregando
  const [tipo, setTipo]           = useState<"whatsapp"|"cpf"|"email">("whatsapp")
  const [email, setEmail]         = useState("")
  const [cpf, setCpf]             = useState(fmtCpf(motorista.cpf))
  const [telefone, setTelefone]   = useState(motorista.telefone||"")
  const [enviar, setEnviar]       = useState("")                   // "" = automatico conforme o tipo de login
  const [enviando, setEnviando]   = useState(false)
  const [erro, setErro]           = useState<string|null>(null)
  const [resultado, setResultado] = useState<any>(null)
  const [copiado, setCopiado]     = useState(false)

  useEffect(()=>{
    let vivo = true
    axios.get(`${API}/motoristas/${motorista.id}/acesso`).then(r=>{ if(vivo) setStatus(r.data) }).catch(()=>{ if(vivo) setStatus({tem_acesso:false}) })
    return ()=>{ vivo = false }
  },[motorista.id, API])

  const foneEnvio = tipo==="whatsapp" ? telefone : motorista.telefone
  const canalAuto = tipo==="email" ? "email" : (celularValido(foneEnvio) ? "whatsapp" : "nenhum")
  const canal = enviar || canalAuto

  const liberar = async () => {
    setErro(null)
    const corpo:any = { login_tipo: tipo, enviar: canal }
    if (tipo==="email")    { if (!EMAIL_RX.test(email.trim())) return setErro("Informe um e-mail válido."); corpo.email = email.trim() }
    if (tipo==="cpf")      { if (!cpfValido(cpf)) return setErro("CPF inválido. Confira os números."); corpo.cpf = soDigitos(cpf) }
    if (tipo==="whatsapp") { if (!celularValido(telefone)) return setErro("Informe o WhatsApp com DDD, por exemplo (91) 99999-0000."); corpo.telefone = telefone }
    if (canal==="whatsapp" && !celularValido(foneEnvio)) return setErro("O motorista não tem um telefone válido cadastrado. Edite o cadastro ou escolha “Não enviar”.")
    if (canal==="email" && tipo!=="email") return setErro("Para enviar por e-mail, escolha o login por e-mail.")
    setEnviando(true)
    try { const r = await axios.post(`${API}/motoristas/${motorista.id}/acesso`, corpo); setResultado(r.data); onMudou() }
    catch(e:any) { setErro(e.response?.data?.erro || "Erro ao liberar o acesso") }
    finally { setEnviando(false) }
  }

  const reenviar = async () => {
    setErro(null); setEnviando(true)
    const canalReenvio = enviar || (status?.login_tipo==="email" ? "email" : (celularValido(motorista.telefone) ? "whatsapp" : "nenhum"))
    try { const r = await axios.post(`${API}/motoristas/${motorista.id}/acesso/reenviar`, { enviar: canalReenvio }); setResultado(r.data); onMudou() }
    catch(e:any) { setErro(e.response?.data?.erro || "Erro ao reenviar o acesso") }
    finally { setEnviando(false) }
  }

  const desativar = async () => {
    if (!window.confirm("Desativar o acesso ao app deste motorista? Ele será desconectado do app agora.")) return
    setErro(null); setEnviando(true)
    try { await axios.delete(`${API}/motoristas/${motorista.id}/acesso`); onMudou(); onFechar() }
    catch(e:any) { setErro(e.response?.data?.erro || "Erro ao desativar o acesso"); setEnviando(false) }
  }

  const copiar = async () => {
    try { await navigator.clipboard.writeText(`Usuário: ${resultado.login_completo}\nSenha provisória: ${resultado.senha_provisoria}`); setCopiado(true) } catch { /* sem permissao de area de transferencia */ }
  }

  const opcao = (id:"whatsapp"|"cpf"|"email", rotulo:string) => (
    <label key={id} className="mt-seg">
      <input type="radio" name="login_tipo" aria-label={rotulo} checked={tipo===id} onChange={()=>{ setTipo(id); setEnviar(""); setErro(null) }} /><span>{rotulo}</span>
    </label>
  )
  useEsc(true, onFechar)

  return (
    <div className="mt-cortina alto">
      <div className="mt-folha estreita" role="dialog" aria-label="Acesso ao app">
        <div className="mt-cab">
          <h3>Acesso ao app — {motorista.nome}</h3>
          <button className="mt-fechar" onClick={onFechar} aria-label="Fechar">✕</button>
        </div>

        <div className="mt-corpo">
        {resultado ? (
          <div>
            {resultado.enviado?.ok ? (
              <div className="mt-caixa ok">
                ✅ <b>Acesso liberado</b> e enviado {resultado.enviado.canal==="email"?"por e-mail":"pelo WhatsApp"} do motorista.
                <div className="mt-sub" style={{marginTop:6}}>Entra por: {resultado.login}. No primeiro acesso o app pede para ele criar a própria senha.</div>
              </div>
            ) : (
              <div className="mt-caixa aviso">
                ⚠️ <b>Acesso liberado</b>, mas o envio automático não foi feito{resultado.enviado?.motivo ? `: ${resultado.enviado.motivo}` : ""}.
                <div className="mt-sub" style={{margin:"6px 0"}}>Passe estes dados ao motorista. <b>A senha aparece só agora</b> e não fica guardada.</div>
                <div className="mt-senha mt-mono">
                  <div>Usuário: <b>{resultado.login_completo}</b></div>
                  <div>Senha provisória: <b>{resultado.senha_provisoria}</b></div>
                </div>
                <button className="btn btn-ghost" style={{marginTop:8}} onClick={copiar}>{copiado?"✓ Copiado":"📋 Copiar"}</button>
              </div>
            )}
            <div className="mt-rodape" style={{padding:"1rem 0 0",border:0}}><button className="btn btn-primary" onClick={onFechar}>Concluir</button></div>
          </div>
        ) : status===null ? (
          <div className="mt-vazio">Carregando...</div>
        ) : status.tem_acesso && status.ativo ? (
          <div>
            <div className="mt-caixa">
              <div>✅ <b>Acesso ativo</b> {status.primeiro_acesso && <span className="mt-pilula aviso">⏳ ainda não criou a própria senha</span>}</div>
              <div className="mt-sub" style={{marginTop:6}}>Entra por: {status.login} ({status.login_tipo==="cpf"?"CPF":status.login_tipo==="whatsapp"?"WhatsApp":"e-mail"})</div>
              <div className="mt-sub">Último acesso: {status.ultimo_acesso ? new Date(status.ultimo_acesso).toLocaleString("pt-BR") : "ainda não entrou"}</div>
            </div>
            <div className="mt-grupo" style={{marginTop:12}}>
              <label className="mt-rotulo">Como enviar a nova senha</label>
              <select className="mt-campo" aria-label="Como enviar" value={enviar} onChange={e=>setEnviar(e.target.value)}>
                <option value="">Automático (WhatsApp, ou e-mail se o login for e-mail)</option>
                <option value="whatsapp">Pelo WhatsApp do motorista</option>
                {status.login_tipo==="email" && <option value="email">Por e-mail</option>}
                <option value="nenhum">Não enviar (eu passo a senha)</option>
              </select>
            </div>
            {erro && <div role="alert" className="mt-erro" style={{marginTop:8}}>{erro}</div>}
            <div style={{display:"flex",gap:8,justifyContent:"space-between",marginTop:16,flexWrap:"wrap"}}>
              <button className="btn btn-ghost btn-perigo" disabled={enviando} onClick={desativar}>⛔ Desativar acesso</button>
              <button className="btn btn-primary" disabled={enviando} onClick={reenviar}>🔁 Reenviar acesso (senha nova)</button>
            </div>
          </div>
        ) : (
          <div style={{display:"flex",flexDirection:"column",gap:".9rem"}}>
            {status.tem_acesso && !status.ativo && <div className="mt-caixa">⛔ O acesso deste motorista está desativado. Ao liberar de novo, ele recebe uma senha nova.</div>}
            <div className="mt-grupo">
              <label className="mt-rotulo">Como o motorista vai entrar no app</label>
              <div className="mt-segs">{opcao("whatsapp","WhatsApp (celular)")}{opcao("cpf","CPF")}{opcao("email","E-mail")}</div>
            </div>
            {tipo==="whatsapp" && (
              <div className="mt-grupo"><label className="mt-rotulo">WhatsApp do motorista</label>
                <input className="mt-campo" aria-label="WhatsApp do motorista" value={telefone} onChange={e=>setTelefone(e.target.value)} placeholder="(91) 99999-0000" inputMode="tel" /></div>
            )}
            {tipo==="cpf" && (
              <div className="mt-grupo"><label className="mt-rotulo">CPF do motorista</label>
                <input className="mt-campo" aria-label="CPF do motorista" value={cpf} onChange={e=>setCpf(fmtCpf(e.target.value))} placeholder="000.000.000-00" inputMode="numeric" /></div>
            )}
            {tipo==="email" && (
              <div className="mt-grupo"><label className="mt-rotulo">E-mail do motorista</label>
                <input className="mt-campo" aria-label="E-mail do motorista" type="email" value={email} onChange={e=>setEmail(e.target.value)} placeholder="motorista@email.com" /></div>
            )}
            {tipo!=="whatsapp" && (
              <div className="mt-dica">Telefone cadastrado: {motorista.telefone || "nenhum"} (para mudar, edite o cadastro do motorista).</div>
            )}
            <div className="mt-grupo">
              <label className="mt-rotulo">Como enviar a senha</label>
              <select className="mt-campo" aria-label="Como enviar" value={canal} onChange={e=>setEnviar(e.target.value)}>
                <option value="whatsapp">Pelo WhatsApp do motorista (com os links do app)</option>
                {tipo==="email" && <option value="email">Por e-mail</option>}
                <option value="nenhum">Não enviar (eu passo a senha)</option>
              </select>
            </div>
            <div className="mt-dica">A senha provisória é gerada pelo sistema. No primeiro acesso o app obriga o motorista a criar a própria.</div>
            {erro && <div role="alert" className="mt-erro">{erro}</div>}
            <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
              <button className="btn btn-ghost" onClick={onFechar}>Cancelar</button>
              <button className="btn btn-primary" disabled={enviando} onClick={liberar}>{enviando?"Liberando...":"✅ Liberar acesso"}</button>
            </div>
          </div>
        )}
        </div>
      </div>
    </div>
  )
}

const badgeApp = (m:any) => {
  if (!m.usuario_id) return <span className="mt-sub">—</span>
  if (!m.acesso_ativo) return <span className="mt-pilula">⛔ Desativado</span>
  if (m.acesso_primeiro) return <span className="mt-pilula aviso">⏳ Aguardando 1º acesso</span>
  return <span className="mt-pilula ok">✅ Ativo</span>
}

export default function Motoristas() {
  const { usuario } = useAuth()
  const [dados, setDados]       = useState<any[]>([])
  const [clientes, setClientes] = useState<any[]>([])
  const [funcoes, setFuncoes]   = useState<any[]>([])
  const [setores, setSetores]   = useState<any[]>([])
  const [busca, setBusca]       = useState("")
  const [modal, setModal]       = useState(false)
  const [editando, setEditando] = useState<any>(null)
  const [form, setForm]         = useState<any>(FORM_VAZIO)
  const [loading, setLoading]   = useState(true)
  const fotoRef = useRef<HTMLInputElement>(null)
  const [acessoDe, setAcessoDe] = useState<any>(null)           // motorista cuja janela de acesso ao app esta aberta
  const [liberarAoSalvar, setLiberarAoSalvar] = useState(false)
  const podeAcesso = usuario?.perfil==='admin' || usuario?.perfil==='superadmin'

  const carregar = async () => {
    try {
      // Garantir que o token está no axios
      const token = localStorage.getItem("moobi_token")||""
      if (token) axios.defaults.headers.common["Authorization"] = `Bearer ${token}`
      const [m, c, g] = await Promise.all([
        axios.get(`${API}/motoristas`),
        axios.get(`${API}/clientes`),
        axios.get(`${API}/grupos`)
      ])
      const lista = Array.isArray(m.data)?m.data:[]
      setDados(lista)
      setEditando((e:any)=> e ? (lista.find((x:any)=>x.id===e.id) ?? e) : e)   // mantem o cadastro aberto com o status do acesso atualizado
      setClientes(Array.isArray(c.data)?c.data:[])
      const grupos = Array.isArray(g.data)?g.data:[]
      setFuncoes(grupos.filter((x:any)=>x.tipo==="funcao"))
      setSetores(grupos.filter((x:any)=>x.tipo==="setor"))
    } catch(e) { console.error("Erro carregar motoristas:", e) }
    finally { setLoading(false) }
  }

  useEffect(()=>{ carregar() },[])

  const abrirNovo = () => { setEditando(null); setLiberarAoSalvar(false); setForm(FORM_VAZIO); setModal(true) }
  const abrirEditar = (m:any) => {
    setEditando(m); setLiberarAoSalvar(false)
    setForm({
      nome:m.nome||"", cnh:m.cnh||"", telefone:m.telefone||"", cpf:fmtCpf(m.cpf),
      cnh_vencimento:m.cnh_vencimento?m.cnh_vencimento.split("T")[0]:"",
      rfid_tag:m.rfid_tag||"", cliente_id:m.cliente_id||"",
      motorista_global:m.motorista_global||false,
      funcao_id:m.funcao_id||"", setor_id:m.setor_id||"", foto_url:m.foto_url||""
    })
    setModal(true)
  }

  const salvar = async () => {
    if (!form.nome) return alert("Nome é obrigatório")
    if (form.cpf && !cpfValido(form.cpf)) return alert("CPF inválido. Confira os números.")
    try {
      let salvo:any = editando
      if (editando) await axios.put(`${API}/motoristas/${editando.id}`, form)
      else { const r = await axios.post(`${API}/motoristas`, form); salvo = r.data }
      setModal(false); await carregar()
      // marcou "liberar acesso ao app" num cadastro novo: agora que o motorista existe, abre a janela dos dados de acesso
      if (!editando && liberarAoSalvar && salvo?.id) setAcessoDe({ ...salvo, ...form, cpf: soDigitos(form.cpf) })
    } catch(e:any) { alert(e.response?.data?.erro||"Erro ao salvar") }
  }

  const excluir = async (id:string) => {
    if (!window.confirm("Excluir motorista?")) return
    try { await axios.delete(`${API}/motoristas/${id}`); carregar() } catch {}
  }

  const uploadFoto = async (file: File) => {
    const fd = new FormData(); fd.append("arquivo", file)
    try {
      const r = await axios.post(`${API}/upload`, fd)
      setForm((f:any) => ({...f, foto_url: r.data.url}))
    } catch { alert("Erro ao enviar foto") }
  }

  const filtrados = dados.filter(d =>
    !busca || d.nome?.toLowerCase().includes(busca.toLowerCase()) ||
    d.cnh?.includes(busca) || d.rfid_tag?.includes(busca)
  )

  const fmtData = (d:any) => d ? new Date(d).toLocaleDateString("pt-BR") : "—"

  const fmtWhatsApp = (tel:string) => {
    if (!tel) return null
    const nums = tel.replace(/\D/g,"")
    const num = nums.startsWith("55") ? nums : `55${nums}`
    return `https://wa.me/${num}`
  }

  const fmtTelefone = (tel:string) => {
    if (!tel) return "—"
    const nums = tel.replace(/\D/g,"")
    if (nums.length === 11) return `(${nums.slice(0,2)}) ${nums.slice(2,7)}-${nums.slice(7)}`
    if (nums.length === 10) return `(${nums.slice(0,2)}) ${nums.slice(2,6)}-${nums.slice(6)}`
    return tel
  }
  const vencCNH = (d:any) => {
    if (!d) return null
    const dias = Math.ceil((new Date(d).getTime()-new Date().getTime())/(1000*60*60*24))
    if (dias < 0) return <span className="mt-pilula perigo">⚠️ Vencida</span>
    if (dias <= 30) return <span className="mt-pilula aviso">⏰ {dias}d</span>
    return <span className="mt-pilula ok">✓ {dias}d</span>
  }
  useEsc(modal && !acessoDe, ()=>setModal(false))

  return (
    <div className="mt dark">
      <style>{CSS}</style>
      <div className="mt-topo">
        <div>
          <h2>Motoristas</h2>
          <p className="mt-mini">{filtrados.length} de {dados.length} registro(s)</p>
        </div>
        <div className="mt-acoes">
          <BotaoExportar endpoint="motoristas" titulo="Motoristas" />
          <button className="btn btn-primary" onClick={abrirNovo}>+ Novo motorista</button>
        </div>
      </div>

      <input className="mt-campo mt-busca" placeholder="Buscar por nome, CNH ou RFID..." aria-label="Buscar motorista" value={busca}
        onChange={e=>setBusca(e.target.value)} />

      <div className="mt-cartao">
        <div className="mt-rolagem">
        <table className="mt-tabela">
          <thead>
            <tr>
              {["Foto","Nome","Função","Setor","CNH","Venc. CNH","Telefone","RFID","App","Ações"].map(h=>(
                <th key={h}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={10} className="mt-vazio">Carregando...</td></tr>
            ) : filtrados.length === 0 ? (
              <tr><td colSpan={10} className="mt-vazio">Nenhum motorista cadastrado</td></tr>
            ) : filtrados.map((m:any)=>(
              <tr key={m.id}>
                <td>
                  {m.foto_url ? (
                    <img className="mt-avatar" src={m.foto_url} alt={m.nome} />
                  ) : (
                    <div className="mt-avatar" aria-hidden="true">{(m.nome||"?").trim().charAt(0).toUpperCase()}</div>
                  )}
                </td>
                <td>
                  <div className="mt-nome">{m.nome}</div>
                  {m.cliente_nome && <div className="mt-sub">{m.cliente_nome}</div>}
                </td>
                <td>{m.funcao_nome||"—"}</td>
                <td>{m.setor_nome||"—"}</td>
                <td className="mt-mono">{m.cnh||"—"}</td>
                <td>
                  <div>{fmtData(m.cnh_vencimento)}</div>
                  {vencCNH(m.cnh_vencimento)}
                </td>
                {/*telefone*/}
                <td>
                  {m.telefone ? (
                    <a className="mt-zap" href={fmtWhatsApp(m.telefone)||"#"} target="_blank" rel="noreferrer">
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="#25D366" aria-hidden="true">
                        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                      </svg>
                      {fmtTelefone(m.telefone)}
                    </a>
                  ) : <span className="mt-sub">—</span>}
                </td>
                <td>
                  {m.rfid_tag ? (
                    <span className="mt-pilula info mt-mono">🏷️ {m.rfid_tag}</span>
                  ) : <span className="mt-sub">—</span>}
                </td>
                <td>{badgeApp(m)}</td>
                <td>
                  <div className="mt-linha-acoes">
                    {podeAcesso && !m.motorista_global && (
                      <button className="mt-icone" title="Acesso ao app do motorista" aria-label={`Acesso ao app de ${m.nome}`}
                        onClick={()=>setAcessoDe(m)}><Icone nome="celular" /></button>
                    )}
                    <button className="mt-icone" title="Editar" aria-label={`Editar ${m.nome}`}
                      onClick={()=>abrirEditar(m)}><Icone nome="editar" /></button>
                    <button className="mt-icone perigo" title="Excluir" aria-label={`Excluir ${m.nome}`}
                      onClick={()=>excluir(m.id)}><Icone nome="lixo" /></button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      </div>

      {modal && (
        <div className="mt-cortina">
          <div className="mt-folha" role="dialog" aria-label={editando?"Editar motorista":"Novo motorista"}>
            <div className="mt-cab">
              <h3>{editando?"Editar motorista":"Novo motorista"}</h3>
              <button className="mt-fechar" aria-label="Fechar" onClick={()=>setModal(false)}>✕</button>
            </div>

            <div className="mt-corpo">
            <div className="mt-topo-form">
              {/* Foto 3x4 */}
              <div className="mt-grupo">
                <span className="mt-rotulo">Foto</span>
                <button type="button" className="mt-foto" aria-label={form.foto_url?"Trocar foto":"Adicionar foto"} onClick={()=>fotoRef.current?.click()}>
                  {form.foto_url ? (
                    <>
                      <img src={form.foto_url} alt="Foto" />
                      <small>Clique p/ trocar</small>
                    </>
                  ) : (
                    <>
                      <div style={{fontSize:28}}>📷</div>
                      <span>Clique para<br/>adicionar foto</span>
                    </>
                  )}
                </button>
                <input ref={fotoRef} type="file" accept="image/*" style={{display:"none"}}
                  onChange={e=>{ const f=e.target.files?.[0]; if(f) uploadFoto(f) }} />
              </div>

              {/* Campos principais */}
              <div className="mt-grade" style={{alignContent:"start"}}>
                <div className="mt-grupo cheio">
                  <label className="mt-rotulo" htmlFor="mt-nome">Nome *</label>
                  <input id="mt-nome" className="mt-campo" value={form.nome} onChange={e=>setForm({...form,nome:e.target.value})} placeholder="Nome completo" />
                </div>
                <div className="mt-grupo">
                  <label className="mt-rotulo" htmlFor="mt-funcao">Função</label>
                  <select id="mt-funcao" className="mt-campo" value={form.funcao_id} onChange={e=>setForm({...form,funcao_id:e.target.value})}>
                    <option value="">— Selecione —</option>
                    {funcoes.map((f:any)=><option key={f.id} value={f.id}>{f.nome}</option>)}
                  </select>
                </div>
                <div className="mt-grupo">
                  <label className="mt-rotulo" htmlFor="mt-setor">Setor</label>
                  <select id="mt-setor" className="mt-campo" value={form.setor_id} onChange={e=>setForm({...form,setor_id:e.target.value})}>
                    <option value="">— Selecione —</option>
                    {setores.map((s:any)=><option key={s.id} value={s.id}>{s.nome}</option>)}
                  </select>
                </div>
              </div>
            </div>

            <div className="mt-grade">
              <div className="mt-grupo">
                <label className="mt-rotulo" htmlFor="mt-cnh">CNH</label>
                <input id="mt-cnh" className="mt-campo" value={form.cnh} onChange={e=>setForm({...form,cnh:e.target.value})} placeholder="Número da CNH" />
              </div>
              <div className="mt-grupo">
                <label className="mt-rotulo" htmlFor="mt-venc">Vencimento CNH</label>
                <input id="mt-venc" className="mt-campo" type="date" value={form.cnh_vencimento} onChange={e=>setForm({...form,cnh_vencimento:e.target.value})} />
                {form.cnh_vencimento && (() => {
                  const dias = Math.ceil((new Date(form.cnh_vencimento).getTime()-new Date().getTime())/(1000*60*60*24))
                  return <div className={`mt-dica ${dias<0?"perigo":dias<=30?"aviso":"ok"}`}>
                    {dias<0?"⚠️ Vencida":dias===0?"Vence hoje":`✓ Vence em ${dias} dias`}
                  </div>
                })()}
              </div>
              <div className="mt-grupo">
                <label className="mt-rotulo" htmlFor="mt-tel">Telefone</label>
                <input id="mt-tel" className="mt-campo" value={form.telefone} onChange={e=>setForm({...form,telefone:e.target.value})} placeholder="(00) 00000-0000" inputMode="tel" />
              </div>
              <div className="mt-grupo">
                <label className="mt-rotulo" htmlFor="mt-cpf">CPF</label>
                <input id="mt-cpf" className="mt-campo" aria-label="CPF do cadastro" value={form.cpf} onChange={e=>setForm({...form,cpf:fmtCpf(e.target.value)})} placeholder="000.000.000-00" inputMode="numeric" />
              </div>
              <div className="mt-grupo">
                <label className="mt-rotulo" htmlFor="mt-rfid">🏷️ Tag RFID</label>
                <input id="mt-rfid" className="mt-campo mt-mono" value={form.rfid_tag} onChange={e=>setForm({...form,rfid_tag:e.target.value})}
                  placeholder="ID do cartão RFID" />
              </div>
              {usuario?.perfil==='superadmin' && (
                <div className="mt-grupo cheio">
                  <label className="mt-troca">
                    <input type="checkbox" role="switch" checked={form.motorista_global}
                      onChange={e=>setForm({...form,
                        motorista_global:e.target.checked,
                        cliente_id:e.target.checked ? "" : form.cliente_id
                      })} />
                    <span className="mt-trilho" aria-hidden="true" />
                    <span><b>🌐 Motorista Global (MoobiFleet)</b><small>Reconhecido em qualquer cliente/whitelabel</small></span>
                  </label>
                </div>
              )}
              {!form.motorista_global && (
                <div className="mt-grupo cheio">
                  <label className="mt-rotulo" htmlFor="mt-cliente">Cliente</label>
                  <select id="mt-cliente" className="mt-campo" value={form.cliente_id} onChange={e=>setForm({...form,cliente_id:e.target.value})}>
                    <option value="">— Selecione —</option>
                    {clientes.map((c:any)=><option key={c.id} value={c.id}>{c.razao_social}</option>)}
                  </select>
                </div>
              )}
            </div>

            {podeAcesso && !form.motorista_global && (
              <div className="mt-bloco">
                <label className="mt-troca">
                  <input type="checkbox" role="switch" aria-label="Liberar acesso ao app" checked={editando ? !!editando.acesso_ativo : liberarAoSalvar}
                    onChange={async e=>{
                      const marcou = e.target.checked
                      if (!editando) { setLiberarAoSalvar(marcou); return }                       // cadastro novo: abre a janela depois de salvar
                      if (marcou) { setAcessoDe({ ...editando, cpf: soDigitos(form.cpf) || editando.cpf, telefone: form.telefone || editando.telefone }); return }
                      if (!window.confirm("Desativar o acesso ao app deste motorista? Ele será desconectado do app agora.")) return
                      try { await axios.delete(`${API}/motoristas/${editando.id}/acesso`); carregar() } catch(err:any) { alert(err.response?.data?.erro||"Erro ao desativar o acesso") }
                    }} />
                  <span className="mt-trilho" aria-hidden="true" />
                  <span>
                    <b>📱 Liberar acesso ao app do motorista</b>
                    <small>
                      {!editando ? "Marque para definir o login e a senha do motorista logo depois de salvar."
                        : editando.acesso_ativo ? "Acesso ativo. Desmarque para desativar." : "Marque para escolher como o motorista vai entrar (e-mail, CPF ou WhatsApp)."}
                    </small>
                  </span>
                </label>
                {editando?.usuario_id && editando.acesso_ativo && (
                  <button type="button" className="mt-link" style={{marginTop:6,marginLeft:"3.55rem"}} onClick={()=>setAcessoDe({ ...editando, cpf: soDigitos(form.cpf) || editando.cpf })}>Gerenciar acesso</button>
                )}
              </div>
            )}
            </div>

            <div className="mt-rodape">
              <button className="btn btn-ghost" onClick={()=>setModal(false)}>Cancelar</button>
              <button className="btn btn-primary" onClick={salvar}>
                {editando?"Salvar alterações":"Cadastrar motorista"}
              </button>
            </div>
          </div>
        </div>
      )}

      {acessoDe && <AcessoApp motorista={acessoDe} API={API} onFechar={()=>setAcessoDe(null)} onMudou={carregar} />}
    </div>
  )
}
